import { queryClient } from '@/config/query/queryClient'
import { actionsQueryKey } from '@/queries/actions.query'
import { borrowPositionsQueryKey } from '@/queries/borrowPositions.query'
import { claimRewardsQueryKey } from '@/queries/claimRewards.query'
import { positionsQueryKey } from '@/queries/positions.query'
import { rewardsQueryKey } from '@/queries/rewards.query'
import { transactionsContextQueryKey } from '@/queries/transactionsContext.query'
import { vaultHolderEventsQueryKey } from '@/queries/vaultHolderEvents.query'
import { walletBalancesQueryKey } from '@/queries/walletBalances.query'

const TRANSACTION_QUERY_KEYS = [
  transactionsContextQueryKey,
  actionsQueryKey,
  walletBalancesQueryKey,
  positionsQueryKey,
  borrowPositionsQueryKey,
  rewardsQueryKey,
  claimRewardsQueryKey,
  vaultHolderEventsQueryKey,
] as const

export const invalidateQueriesGlobally = async () => {
  await Promise.all(TRANSACTION_QUERY_KEYS.map((queryKey) => queryClient.invalidateQueries({ queryKey })))
}
